import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
import "material-icons/iconfont/material-icons.css";
import { restoreKeycloakSession } from "@/utils/keycloak";

Vue.use(Vuesax, {
  theme: {
    colors: {
      default: "#005B9B",
      primary: "#005B9B",
      success: "rgb(23, 201, 100)",
      danger: "#B40000",
      warning: "rgb(238,174,91)", //'rgb(255, 130, 0)'
      dark: "rgb(25, 135, 84)",
    },
  },
});

Vue.config.productionTip = false;
Vue.prototype.$debug = true;

import "bootstrap/dist/css/bootstrap.css";
import "@/assets/css/BOS-ID.css";

import InputFacade from "vue-input-facade";
Vue.use(InputFacade);

import { i18n } from "./plugins/i18n";

// VUE AXIOS
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

// Vue.axios.defaults.baseURL = process.env.VUE_APP_BOSID_API_HOST
// Vue.axios.defaults.crossDomain = true;

Vue.axios.defaults.withCredentials = true;
Vue.axios.defaults.mode = "cors";
Vue.axios.defaults.credentials = "include";
Vue.axios.defaults.timeout = 120000;

//  VUE COOKIES
import VueCookies from "vue-cookies";

// default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' }
Vue.use(VueCookies, { expire: "7d" });

Vue.axios.interceptors.response.use(
  (response) => response,
  async function(error) {
    if (error.response.status === 401) {
      const noRetryPaths = [
        "/api/v1/accounts/token/refresh",
        "/api/v2/accounts/login",
        "/api/v2/accounts/login-type",
      ];
      const origConfig = error.response.config;
      const isNoRetryUrl = noRetryPaths.some((path) =>
        origConfig.url.endsWith(path),
      );

      if (!isNoRetryUrl && !origConfig._retry) {
        origConfig._retry = true;

        const isKeycloak = store.getters["auth/isKeycloakAuth"];

        if (isKeycloak) {
          // ✅ Keycloak: Token refreshen, dann Request wiederholen
          try {
            await store.dispatch("auth/refreshToken");
            origConfig.headers = await store.dispatch("auth/getHeaders", null, {
              root: true,
            });
            return axios.request(origConfig);
          } catch (e) {
            // Refresh fehlgeschlagen → ausloggen
            await store.dispatch("auth/makeLogout");
            return Promise.reject(error);
          }
        } else {
          // ✅ Lokaler Login: wie bisher
          await store.dispatch("auth/refreshToken");
          origConfig.headers = await store.dispatch("auth/getHeaders", null, {
            root: true,
          });
          return axios.request(origConfig);
        }
      } else {
        // ✅ Kein weiterer Retry → zur Login-Seite
        router.push({ name: "Login" });
      }

      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

// DEBUG MODE
Vue.mixin({
  data: function() {
    return {
      get isDebugMode() {
        return false;
      },
    };
  },
});

Vue.use(require("vue-moment"));
(async () => {
  const loginType = sessionStorage.getItem("kc_login_type");
  const isKeycloakCallback = window.location.pathname === "/login-callback";

  if (loginType === "keycloak_oauth2" && !isKeycloakCallback) {
    try {
      const restored = await restoreKeycloakSession();

      if (restored) {
        // Store direkt befüllen BEVOR Vue mounted
        await store.dispatch("auth/fetchUserInfo");
      } else {
        // Session abgelaufen → aufräumen
        sessionStorage.removeItem("kc_token");
        sessionStorage.removeItem("kc_refresh_token");
        sessionStorage.removeItem("kc_id_token");
        sessionStorage.removeItem("kc_login_type");
        sessionStorage.removeItem("auth_user");
      }
    } catch (e) {
      console.error("Session restore fehlgeschlagen:", e);
      sessionStorage.removeItem("kc_token");
      sessionStorage.removeItem("kc_refresh_token");
      sessionStorage.removeItem("kc_id_token");
      sessionStorage.removeItem("kc_login_type");
      sessionStorage.removeItem("auth_user");
    }
  }

  new Vue({ router, store, i18n, render: (h) => h(App) }).$mount("#app");
})();
